export default "__VITE_ASSET__CcPz3iBl__"